import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as rolesActions from "store/entities/settingsInfo/action";

import FormDrawer from '../form-drawer';
import ViewRoleModal from "components/__new/common/form/ViewRolePermission";
import { nameInitials } from 'utils/nameInitials';
import {renderRoleColor} from "utils/statusColor"
import DateFormat, { DateTimeFormat } from 'utils/dateFormat';





const ViewTeamMemberModal = (props) => {
const {isOpen, setIsOpen, data: member} = props;
const dispatch = useDispatch() 

const { rolePermission } = useSelector(state => state.entities.settingsInfo)

const [allowViewRoleModal, setAllowViewRoleModal] = useState(false);


const getCurrentRolePermission = () => {
    dispatch(rolesActions.getRolePermission(member?.roleId))
    }
    
useEffect(() => {
    if(member){
        getCurrentRolePermission()
    }
}, [member?.roleId]);


    return (
        <FormDrawer display="center" size="sm" isOpen={isOpen} setIsOpen={setIsOpen}>
                <div className="p-6">
                    <FormDrawer.Title
                        close={setIsOpen}
                    />
                    
                    <ViewRoleModal 
                        isOpen={allowViewRoleModal}
                        setIsOpen={setAllowViewRoleModal}
                        title={member?.role?.name || 'Role'}
                        data={rolePermission?.data || []}
                    />
                    
                    {/* <ViewUserRoleModal 
                        isOpen={allowViewRoleModal}
                        setIsOpen={setAllowViewRoleModal}
                        data={ []}
                    /> */}
                    
                    <div className='flex my-3 p-3'>
                        {!member.employer?.profileImage ?
                            <div className='flex justify-center w-16 h-16'>
                                <img width='56' height='56' className="rounded-full object-cover" src={member.employer?.profileImage} alt="member" />
                            </div> :
                            <div className='p-3 rounded-full bg-ep-primary text-white'>
                                <div>{nameInitials(member.firstName, member.lastName)}</div>
                            </div> 
                        }
                        <div className='pl-3'>
                            <div className='font-medium'>{member.firstName + ' ' + member.lastName}</div>
                            <div className='text-ep-gray-500'>{member.email}</div>
                        </div>
                    </div>
                    <div className='flex justify-between'>
                        <div className='text-ep-gray-500'>
                            <div>Last Login</div>
                            <div className='py-3'>Role</div>
                            <div>Permissions</div>
                        </div>
                        <div>
                            <div className='font-medium pb-3'>{DateTimeFormat(member.updatedAt)}</div>
                            <div className={"label font-medium py-3" + renderRoleColor(member?.role?.name?.toLowerCase())}>
                                {member.role?.name}
                            </div>  
                            <div onClick={() => setAllowViewRoleModal(true)} className='pt-3 cursor-pointer underline text-ep-primary-600 font-medium'>View Permissions</div>
                        </div>
                    </div>
                    <div className='mt-5'>
                        <div onClick={() => setIsOpen(prev => !prev)} className='cursor-pointer bg-ep-primary-600 text-white text-center p-2 rounded-lg'>Close</div>
                    </div>
                </div>
        </FormDrawer>
  )
}

export default ViewTeamMemberModal